import {Reducer} from 'redux'
import {DepartmentsActionTypes, DepartmentsState} from './types';
import DepartmentsService from "../../services/DepartmentsService";

// Type-safe initialState!
const initialState: DepartmentsState = {
	list: []
}

// Thanks to Redux 4's much simpler typings, we can take away a lot of typings on the reducer side,
// everything will remain type-safe.
const reducer: Reducer<DepartmentsState> = (state = initialState, action) => {
	switch (action.type) {
		case DepartmentsActionTypes.FETCH_ALL_REQUEST: { 
			DepartmentsService.getAll()
			return { ...state, loading: true }
		}
		case DepartmentsActionTypes.FETCH_ALL_COMPLETED: {
			return { ...state, loading: false, list: action.payload}
		}
		case DepartmentsActionTypes.FETCH_ONE_REQUEST: {
			DepartmentsService.getOne(action.payload)
			return { ...state, loading: true }
		}
		case DepartmentsActionTypes.FETCH_ONE_COMPLETED: {
			let foundIndex = state.list.findIndex(element => element.id === action.payload.id)
			state.list.splice(foundIndex, 1, action.payload)
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		case DepartmentsActionTypes.SAVE_REQUEST: {
			DepartmentsService.save(action.payload)
			return { ...state, loading: true }
		}
		case DepartmentsActionTypes.SAVE_COMPLETED: {
			return { ...state, loading: false}
		}
		case DepartmentsActionTypes.DELETE_REQUEST: {
			DepartmentsService.delete(action.payload)
			return { ...state, loading: true }
		}
		case DepartmentsActionTypes.DELETE_COMPLETED: {
			let foundIndex = state.list.findIndex(element => element.id === action.payload.id)
			state.list.splice(foundIndex, 1)
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		case DepartmentsActionTypes.DELETE_MULTIPLE_REQUEST: {
			DepartmentsService.deleteMultiple(action.payload)
			return { ...state, loading: true }
		}
		case DepartmentsActionTypes.DELETE_MULTIPLE_COMPLETED: {
			action.payload.forEach((item: any) => {
				let foundIndex = state.list.findIndex(element => element.id === item.id)
				state.list.splice(foundIndex, 1)
			});
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		default: {
			return state
		}
	}
}

// Instead of using default export, we use named exports. That way we can group these exports
// inside the `index.js` folder.
export { reducer as DepartmentsReducer }
